import React from 'react';
import { Container, Row } from 'react-bootstrap';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { createImageViewerButton, createImageViewer } from '../../helpers/imageViewerHelpers';
import { createStyledImageListItemBar } from '../../helpers';
import billy from '../../Assets/3dModelling/Billy/3DmodelBilly.jpg';
import billyFront from '../../Assets/3dModelling/Billy/3DmodelBillyFront.jpg';
import duckling from '../../Assets/3dModelling/Duckling/3DModelDuckling.jpg';
import kid from '../../Assets/3dModelling/Kid/3dModelKid.jpg';
import sleep from '../../Assets/3dModelling/Sleep/3DmodelSleep.jpg';
import vervelo from '../../Assets/3dModelling/Vervelo/3DmodelVervelo.jpg';


const billyCharacterDesignData = [
  {
    img: billy,
    title: 'Character Model - Billy',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: billyFront,
    title: 'Character Model Front - Billy',
    author: 'Nikoletta Papakonstantinou',
  },
];

const ducklingCharacterDesignData = [
  {
    img: duckling,
    title: 'Character Model - Duckling',
    author: 'Nikoletta Papakonstantinou',
  },
];

const kidCharacterDesignData = [
  {
    img: kid,
    title: 'Character Model - Kid',
    author: 'Nikoletta Papakonstantinou',
  },
];

const sleepCharacterDesignData = [
  {
    img: sleep,
    title: 'Character Model - Sleep',
    author: 'Nikoletta Papakonstantinou',
  },
];

const verveloCharacterDesignData = [
  {
    img: vervelo,
    title: 'Character Model - Vervelo',
    author: 'Nikoletta Papakonstantinou',
  },
];

function Modelling() {
  // Image viewer state
  const [currentBillyImage, setCurrentBillyImage] = React.useState(0);
  const [billyViewerOpen, setBillyViewerOpen] = React.useState(false);
  const [currentDucklingImage, setCurrentDucklingImage] = React.useState(0);
  const [ducklingViewerOpen, setDucklingViewerOpen] = React.useState(false);
  const [currentKidImage, setCurrentKidImage] = React.useState(0);
  const [kidViewerOpen, setKidViewerOpen] = React.useState(false);
  const [currentSleepImage, setCurrentSleepImage] = React.useState(0);
  const [sleepViewerOpen, setSleepViewerOpen] = React.useState(false);
  const [currentVerveloImage, setCurrentVerveloImage] = React.useState(0);
  const [verveloViewerOpen, setVerveloViewerOpen] = React.useState(false);

  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Character 3D Model - Billy</strong>
        </h1>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>

      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {billyCharacterDesignData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setCurrentBillyImage(index);
                setBillyViewerOpen(true);
              },
              characterType: 'Billy Character Model'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Character 3D Model - Duckling</strong>
        </h1>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {ducklingCharacterDesignData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setCurrentDucklingImage(index);
                setDucklingViewerOpen(true);
              },
              characterType: 'Duckling Character Model'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Character 3D Model - Kid</strong>
        </h1>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {kidCharacterDesignData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setCurrentKidImage(index);
                setKidViewerOpen(true);
              },
              characterType: 'Kid Character Model'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Character 3D Model - Sleep</strong>
        </h1>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {sleepCharacterDesignData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setCurrentSleepImage(index);
                setSleepViewerOpen(true);
              },
              characterType: 'Sleep Character Model'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Character 3D - Vervelo</strong>
        </h1>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {verveloCharacterDesignData.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setCurrentVerveloImage(index);
                setVerveloViewerOpen(true);
              },
              characterType: 'Vervelo Character Model'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>

      {/* All Image Viewers at the top level for full-screen display */}
      {createImageViewer({
        isOpen: billyViewerOpen,
        images: billyCharacterDesignData.map(item => item.img),
        currentIndex: currentBillyImage,
        onClose: () => setBillyViewerOpen(false),
      })}

      {createImageViewer({
        isOpen: ducklingViewerOpen,
        images: ducklingCharacterDesignData.map(item => item.img),
        currentIndex: currentDucklingImage,
        onClose: () => setDucklingViewerOpen(false)
      })}

      {createImageViewer({
        isOpen: kidViewerOpen,
        images: kidCharacterDesignData.map(item => item.img),
        currentIndex: currentKidImage,
        onClose: () => setKidViewerOpen(false)
      })}

      {createImageViewer({
        isOpen: sleepViewerOpen,
        images: sleepCharacterDesignData.map(item => item.img),
        currentIndex: currentSleepImage,
        onClose: () => setSleepViewerOpen(false)
      })}

      {createImageViewer({
        isOpen: verveloViewerOpen,
        images: verveloCharacterDesignData.map(item => item.img),
        currentIndex: currentVerveloImage,
        onClose: () => setVerveloViewerOpen(false)
      })}
    </Container>
  );
}

export default Modelling;
